const moment = require('moment')

export const prepareEmail = (values, prices, form) => {
  const { clientMailData, vendorMailData } = getBodies(values, prices, form)
  return {
    vendor_recipient: process.env.GATSBY_VENDOR_MAIL,
    vendor_title: vendorMailData.title,
    vendor_body: vendorMailData.body,
    client_recipient: clientMailData.recipient,
    client_title: clientMailData.title,
    client_body: clientMailData.body
  }
}

export const sendEmail = body =>
  fetch(process.env.GATSBY_ZAPIER_WEBHOOK_URL, {
    method: 'POST',
    mode: 'no-cors',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  })

const getBodies = (values, prices, form) => {
  const cb = form.email.client_body
  const vb = form.email.vendor_body

  return {
    clientMailData: {
      recipient: values.payment.address.email,
      title: `${cb.mail_subject}`,
      body: [
        cb.pretext
          .replace('[firstname]', values.payment.address.given_name)
          .replace('[name]', values.payment.address.family_name),
        '',
        ...clientBody(values, cb, prices, form).filter(e => e !== 'empty'),
        '',
        cb.aftertext
      ].join('<br/>')
    },

    vendorMailData: {
      title: `${vb.mail_subject}`,
      body: [
        ...vendorBody(values, vb, prices, form).filter(e => e !== 'empty')
      ].join('<br/>')
    }
  }
}

const clientBody = (values, data, prices, form) => {
  const p_add = values.payment.address
  const chars = getCharsSummary(values)
  const colors = getFlowersSummary(values)
  return [
    `<strong>${data.recipient}</strong>`,
    `${data.gender}: ${values.chars.gender}`,
    `${data.characteristics}: ${chars === ' default' ? data.default : chars}`,
    `${data.age}: ${values.chars.age}`,
    `${data.story}: ${values.chars.story}`,
    ``,
    `<strong>${data.bouquet}</strong>`,
    `${data.price}: ${data.currency} ${parseInt(prices.bouquet).toFixed(2)}`,
    `${data.shape}: ${values.bouquet.size}, ${values.bouquet.shape}`,
    `${data.color}: ${colors === ' default' ? data.default : colors}`,
    `${data.bouquet_notes}: ${values.bouquet.comments}`,
    ``,
    `<strong>${data.card}</strong>`,
    `${getCardSummary(values, form, data)}`,
    `${data.card_text}: ${values.card.card_text}`,
    `${data.price}: ${data.currency} ${parseInt(prices.card).toFixed(2)}`,
    ``,
    ...getDeliveryMethod(values, form, data),
    ``,
    `<strong>${data.from}</strong>`,
    `${data.name}: ${p_add.company} ${p_add.given_name} ${p_add.family_name}`,
    `${data.street}: ${p_add.street} ${p_add.house_number}`,
    `${data.city}: ${p_add.postal_code} ${p_add.city}`,
    `${data.email}: ${p_add.email}`,
    `${data.tel}: ${p_add.tel}`,
    `${data.payment_notes}: ${values.delivery.comments}`,
    ``,
    `<strong>${data.delivery}</strong>`,
    `${data.delivery_type}: ${values.delivery.method}`,
    `${data.delivery_time}: ${getTime(values, form)}`,
    `${data.delivery_costs}: ${data.currency} ${getDeliveryCost(prices)}`,
    `${
      prices.urgent_delivery && prices.urgent_delivery !== 0
        ? `${data.express_delivery}: ${data.currency} 5.00`
        : 'empty'
    }`,
    `${data.total}: ${data.currency} ${getTotal(prices)}`,
    `${data.vat}`,
    `${data.payment}: ${values.payment.method}`
  ]
}

const vendorBody = (values, data, prices, form) => {
  const chars = getCharsSummary(values)
  const colors = getFlowersSummary(values)
  return [
    `<strong>${data.person}</strong>`,
    `${data.gender}: ${values.chars.gender}`,
    `${data.characteristics}: ${chars === ' default' ? data.default : chars}`,
    `${data.age}: ${values.chars.age}`,
    `${data.story}: ${values.chars.story}`,
    ``,
    `<strong>${data.bouquet}</strong>`,
    `${data.price}: ${data.currency} ${parseInt(prices.bouquet).toFixed(2)}`,
    `${data.shape}: ${values.bouquet.size}, ${values.bouquet.shape}`,
    `${data.color}: ${colors === ' default' ? data.default : colors}`,
    `${data.bouquet_notes}: ${values.bouquet.comments}`,
    ``,
    `<strong>${data.card}</strong>`,
    `${getCardSummary(values, form, data)}`,
    `${data.card_text}: ${values.card.card_text}`,
    `${data.price}: ${data.currency} ${parseInt(prices.card).toFixed(2)}`,
    ``,
    `<strong>${data.from}</strong>`,
    ...getDeliveryAddress(values, form, data),
    `${data.payment_notes}: ${values.delivery.comments}`,
    ``,
    `<strong>${data.delivery}</strong>`,
    `${data.delivery_type}: ${values.delivery.method}`,
    `${data.delivery_time}: ${getTime(values, form)}`,
    `${data.delivery_costs}: ${data.currency} ${getDeliveryCost(prices)}`,
    `${
      prices.urgent_delivery && prices.urgent_delivery !== 0
        ? `${data.express_delivery}: ${data.currency} 5.00`
        : 'empty'
    }`,
    `${data.total}: ${data.currency} ${getTotal(prices)}`,
    ``,
    `${data.payment}: ${values.payment.method}`,
    `${data.newsletter}: ${values.summary.newsletter ? data.yes : data.no}`
  ]
}

export const getDeliveryMethod = (values, form, data) => {
  const address = values.delivery.address
  return values.delivery.method === form.delivery.method.values[0]
    ? [
      `<strong>${data.address}</strong>:`,
      `${data.company}: ${address.company} ${address.given_name} ${
        address.family_name
      }`,
      `${data.street}: ${address.street} ${address.house_number}`,
      `${data.city}: ${address.postal_code} ${address.city}`,
      `${data.tel}: ${address.tel}`
    ]
    : [`<strong>${data.pick_up}</strong>`, `${data.pickup_address}`]
}

export const getDeliveryAddress = (values, form, data) => {
  let address = values.payment.address
  if (values.delivery.method === form.delivery.method.values[0]) {
    address = values.delivery.address
  }
  return [
    `${data.name}: ${address.company} ${address.given_name} ${
      address.family_name
    }`,
    `${data.street}: ${address.street} ${address.house_number}`,
    `${data.city}: ${address.postal_code} ${address.city}`,
    `${data.email}: ${address.email}`,
    `${data.tel}: ${address.tel}`
  ]
}

export const getCharsSummary = values =>
  `${Object.keys(values.chars.characteristics).reduce(
    (acc, c, i, arr) =>
      `${acc}${values.chars.characteristics[arr[i]] ? ` ${arr[i]}` : ''}`,
    ''
  )}`

export const getFlowersSummary = values =>
  `${Object.keys(values.bouquet.color).reduce(
    (acc, c, i, arr) =>
      `${acc}${values.bouquet.color[arr[i]] ? ` ${arr[i]}` : ''}`,
    ''
  )}`

export const getCardSummary = (values, form, data) =>
  `${values.card.card === form.card.card.values[0] ? data.yes : data.no}`

export const getTime = (values, form) => {
  let time = 0
  if (values.delivery.method === form.delivery.method.values[0]) {
    const times = [
      '10:00-12:00',
      '12:00-14:00',
      '14:00-16:00',
      '16:00-18:00',
      values.delivery.specific_time
    ]
    const id = [form.delivery.time.values.indexOf(values.delivery.time)]
    time = times[id]
  } else {
    time = values.delivery.pickup_time
  }

  return (
    values.delivery.date &&
    time &&
    `${moment(`${values.delivery.date}`).format('DD MMMM YYYY')} ${time}`
  )
}

const sum = arr => arr.reduce((p, c) => p + (c || 0), 0)

export const getDeliveryCost = prices =>
  parseInt(
    sum([
      prices.urgent_delivery,
      prices.life_zone,
      prices.specific_time,
      prices.rush_hour,
      prices.pickup_time
    ])
  ).toFixed(2)

export const getTotal = prices =>
  parseInt(
    sum([
      prices.bouquet,
      prices.card,
      prices.urgent_delivery,
      prices.life_zone,
      prices.specific_time,
      prices.rush_hour,
      prices.pickup_time
    ])
  ).toFixed(2)
